var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 820",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250.878 33.995c-128.448 0-235.36 111.211-235.36 231.881 0 54.287 30.563 123.27 52.645 170.912l181.855 349.25 180.995-349.25c22.082-47.643 53.505-113.166 53.505-170.912 0-120.67-105.193-231.881-233.64-231.881zm0 139.82c50.496.333 91.435 41.468 91.435 92.042s-40.94 91.123-91.435 91.436c-50.496-.333-91.436-40.843-91.436-91.436 0-50.574 40.94-91.71 91.436-92.042z",
    strokeWidth: 21.49587,
    fill: "#0f0",
    stroke: "#06c100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker3);
export default __webpack_public_path__ + "static/media/marker3.77e892264a8538e840136f253a3f9928.svg";
export { ForwardRef as ReactComponent };